import { FulfillmentTypes } from "@jackfruit/common"
import { getOrderedProducts } from "~/redux/state/printServiceProducts"
import { useAllProducts } from "./useAllProducts"
import { usePage } from "./usePage"

export const useCurrentAvailableProductsForPageAndDefaultFultillment = () => {
  const allProducts = useAllProducts()
  const { page } = usePage()

  const {
    products: productConfiguration,
    printServices: printServiceConfiguration,
    defaultFulfillment,
  } = page

  const printServiceForFulfillment =
    printServiceConfiguration[defaultFulfillment as FulfillmentTypes][0]

  const printServiceId = Number(printServiceForFulfillment?.id)

  const productConfigurationForFulfillment =
    productConfiguration[defaultFulfillment as FulfillmentTypes][printServiceId]

  const products = getOrderedProducts(
    allProducts,
    productConfigurationForFulfillment
  )

  return { products }
}
